<template>
    <div class="card">
        <v-server-table
            class="dashboard"
            url="/dtable/earlykitparts"
            :columns="columns"
            :options="options"
        >
            <template slot="beforeFilter">
                <h4 class="card-title">
                    {{ $t("dashboard.earlykit_title") }}
                    <p class="card-category text-muted">{{ $t("dashboard.earlykit_subtitle") }}</p>
                </h4>
            </template>
            <template
                slot="created_at"
                slot-scope="props"
            >{{ props.row.created_at | moment("DD/MM/YYYY") }}</template>
        </v-server-table>
    </div>
</template>

<script>
export default {
  data() {
    return {
      columns: [
        "asf",
        "part",
        "sku",
        "quantity"
      ],
      options: {
        perPage: 10,
        perPageValues: [],
        headings: {
          asf: this.$t('field.asf'),
          part: this.$t('field.name'),
          sku: this.$t('field.sku'),
          quantity: this.$t('field.quantity'),
          id: ""
        },
        texts: {
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
        },
        orderBy: {
          ascending: true,
          column: "quantity"
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-xs table-hover",
        pagination: {
          edge: true
        },
        params: {
          asf: this.$store.getters["auth/getCurrentAsf"]
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  }
};
</script>
